import React, { useState } from 'react';
import { Layout, Menu, Typography } from 'antd';
import { DollarCircleOutlined } from '@ant-design/icons';
import Salaries from './Salaries';
import Bulletins from './Bulletins';
import GestionPrets from './GestionPrets';
import ParametresPaie from './ParametresPaie';
import ModelisationComptable from './ModelisationComptable';
import "../Pages/CSS/Traitement.css";
const { Sider, Content } = Layout;
const { Title, Paragraph } = Typography;
const GestionPaie = () => {

  const [currentMenu, setCurrentMenu] = useState('Bulletins Salariés');


  const renderContent = () => {
    switch (currentMenu) {
      case 'Salariés':
        return <Salaries />;
      case 'Bulletins Salariés':
        return <Bulletins />;
      case 'Liste des Prêts':
        return <GestionPrets />;
      case 'Paramètres Paie':
        return <ParametresPaie />;
      case 'Modélisation Comptable':
        return <ModelisationComptable />;
      default:
        return <Bulletins />;
    }
  };

  return (
    <div style={{ padding: '0 12px 12px 12px' }}>
      {/* En-tête moderne */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 20,
        }}
      >
        <DollarCircleOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
            margin: 0,
          }}
        >
          Gestion de Paie
        </span>
      </div>

      {/* Contenu avec menu latéral */}
      <Layout style={{ minHeight: 400, borderRadius: 10, overflow: 'hidden' }}>
        <Sider width={220} style={{ background: '#fff' }}>
          <Menu
            mode="vertical"
            selectedKeys={[currentMenu]}
            onClick={(e) => setCurrentMenu(e.key)}
            style={{ height: "100%", borderRight: '1px solid #f0f0f0' }}
          >
            <Menu.Item key="Salariés">Salariés</Menu.Item>
            <Menu.Item key="Bulletins Salariés">Bulletins Salariés</Menu.Item>
            <Menu.Item key="Liste des Prêts">Gestion des Prêts</Menu.Item>
            <Menu.Item key="Paramètres Paie">Paramètres Paie</Menu.Item>
            <Menu.Item key="Modélisation Comptable">Modélisation Comptable</Menu.Item>
          </Menu>
        </Sider>
        <Layout>
          <Content style={{ padding: '16px 20px', backgroundColor: '#fff' }}>
            <Title level={4} style={{ marginTop: 0, marginBottom: 16 }}>{currentMenu}</Title>
            {renderContent()}
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default GestionPaie;
